/** /support. The queue, the SLA pills and the bulk bar. */
import { createRoute } from '@tanstack/react-router';
import { Route as shellRoute } from '../_shell';
import { TicketQueue } from '@/features/support/TicketQueue';

function SupportPage() {
  return (
    <TicketQueue
      onOpen={(ref) => {
        window.location.assign(`/support/${encodeURIComponent(ref)}`);
      }}
    />
  );
}

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/support',
  component: SupportPage,
});
